/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiagLab from './diag-lab';
import DiagLabDetail from './diag-lab-detail';
import DiagLabUpdate from './diag-lab-update';
import DiagLabDeleteDialog from './diag-lab-delete-dialog';

const DiagLabRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiagLab />} />
    <Route path="new" element={<DiagLabUpdate />} />
    <Route path=":id">
      <Route index element={<DiagLabDetail />} />
      <Route path="edit" element={<DiagLabUpdate />} />
      <Route path="delete" element={<DiagLabDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiagLabRoutes;
